var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"info",attrs:{"data-title":"Confirmation"}},[_c('div',{staticClass:"cellcopy"},[_c('el-result',{attrs:{"icon":"success","title":"Successfully submitted !","subTitle":"We will contact you as soon as possible."}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }